module.exports = __webpack_public_path__ + "img/download-nt-prod-backup.e26dd739.png";